export default "__VITE_ASSET__69ed49e1__"